// frontend/src/contexts/AnticipatoryContext.tsx
// TaisaCore Sprint 10: Anticipatory Layout Context

import React, { createContext, ReactNode } from 'react';
import { useAnticipatoryLayout } from '../hooks/useAnticipatoryLayout';
import { AnticipatoryContextValue, UserRole } from '../types/dashboard';

export const AnticipatoryContext = createContext<AnticipatoryContextValue | null>(null);

interface AnticipatoryProviderProps {
  children: ReactNode;
  initialRole?: UserRole;
}

export const AnticipatoryProvider: React.FC<AnticipatoryProviderProps> = ({
  children,
  initialRole = 'dentist',
}) => {
  const value = useAnticipatoryLayout(initialRole);

  return (
    <AnticipatoryContext.Provider value={value}>
      {children}
    </AnticipatoryContext.Provider>
  );
};

// Custom hook for using anticipatory layout
export const useAnticipatoryContext = (): AnticipatoryContextValue => {
  const context = React.useContext(AnticipatoryContext);
  if (!context) {
    throw new Error('useAnticipatoryContext must be used within an AnticipatoryProvider');
  }
  return context;
};

export default AnticipatoryContext;
